import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-conditions-utilisation',
    templateUrl: './conditions-utilisation.component.html',
    styleUrls: ['./conditions-utilisation.component.scss'],
    imports: [
        TranslateModule
    ]
})
export class ConditionsUtilisationComponent {

}
